import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { techPartnersMission } from "@/mocks/techPartnersData";

export default function TechPartnersMission() {
  return (
    <section className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-6 md:mb-8">
              <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                / Our Mission
              </span>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <p className="text-lg md:text-xl text-white/80 leading-relaxed">
              {techPartnersMission.text}
            </p>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/collaborate"
                className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-tie-teal text-white font-medium text-sm md:text-base hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap"
              >
                Become a Technology Partner
                <i className="ri-arrow-right-line ml-2" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-white/10 text-white border border-white/30 font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
              >
                Speak to an Advisor
                <i className="ri-phone-line ml-2" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}